export enum TextSection {
  RSVP_CLOSED = 'rsvp-closed',
  RSVP = 'rsvp',
  TODAY = 'today',
  NONE = '',
}
